import { useContext, useEffect, useState } from 'react'
import { Form, DatePicker } from 'antd'
const { RangePicker } = DatePicker

import { SL_Modal } from '../../../components/modal/Modal'
import { SL_Button } from '../../../components/buttons/Button'
import { SL_Input } from '../../../components/input/Input'
import { FormItem } from '../../settingsModal/components/FormItem'
import { GS_Select } from '../../../components/select/GS_Select'
import { ChoseCentral } from './ChoseCentral'

import { EAlertTypes } from '../../../enums/EAlertTypes'
import { GeneralContext } from '../../../context/GeneralContext/GeneralContext'
import { displayMessage } from '../../../helpers/messages'
import { colors } from '../../../services/style'
import api from '../../../services/api'

export const FiltersModal = ({ onClose, filters = [], onFilter, central_id }) => {
    const { showAlert, windowWidth } = useContext(GeneralContext)
    const [central, setCentral] = useState(central_id)

    const [deviceTypes, setDeviceTypes] = useState([])
    const [alertTypes, setAlertTypes] = useState([])
    const [sectors, setSectors] = useState([])

    const [form] = Form.useForm()

    const onFinish = (values) => {
        if (!central) {
            showAlert(displayMessage('CHOSE_CENTRAL'), EAlertTypes.ERROR)
            return
        }
        const obj = {
            filters: values,
        }

        const { datetime, filterName } = values
        const selects = ['deviceType', 'sector', 'alertType']

        selects.forEach((select) => {
            if (values[select]) {
                obj.filters[select] = values[select]
            }
        })

        if (datetime) {
            obj.filters.dateTimeFrom = new Date(datetime[0].$d).toISOString()
            obj.filters.dateTimeTo = new Date(datetime[1].$d).toISOString()
        }

        if (filterName) {
            obj.filterName = filterName
        }
        onFilter(obj, central)
        onClose()
    }

    async function loadSectors() {
        try {
            const { data } = await api.sectors.listByCentral(central)
            setSectors(
                data.map((sector) => {
                    const { name, gs_id } = sector
                    return { label: name, value: gs_id }
                })
            )
        } catch (error) {
            console.error(error)
        }
    }

    async function loadAlertTypes() {
        try {
            const { data } = await api.alertTypes.alertsByCentral(central)

            setAlertTypes(
                data.map((alert) => {
                    const { name, gs_id } = alert
                    return { label: name, value: gs_id }
                })
            )
        } catch (error) {
            console.error(error)
        } finally {
        }
    }

    async function loadDeviceTypes() {
        try {
            const { data } = await api.deviceTypes.list()
            setDeviceTypes(
                data.map((type) => {
                    const { name, gs_id } = type
                    return { label: name, value: gs_id }
                })
            )
        } catch (error) {
            console.error(error)
        }
    }

    useEffect(() => {
        if (central) {
            if (filters.includes('deviceType')) loadDeviceTypes()
            if (filters.includes('sector')) loadSectors()
            if (filters.includes('alertType')) loadAlertTypes()
        }
    }, [filters, central])

    return (
        <SL_Modal
            open={true}
            centered={false}
            title={
                <div style={{ borderBottom: `1px solid ${colors['sl-gray'][100]}` }} className={`w-full report-table-title-div flex text-white flex-wrap justify-between items-center`}>
                    <div className="flex gap-3">
                        <h3 className="text-medium report-table-title">{displayMessage('FILTERS')}</h3>
                    </div>

                    <ChoseCentral onChangeCentral={setCentral} central_id={central_id} />

                    <div className="flex gap-3 items-start p-1">
                        <SL_Button type="default" className="bg-white/10 hover:bg-white/20 text-white rounded settings-modal--button flex justify-center items-center font-medium" onClick={onClose}>
                            <span className="form-label">{displayMessage('CANCEL')}</span>
                        </SL_Button>
                        <SL_Button
                            type="default"
                            className="bg-primary-600 hover:bg-primary-600/80 text-white rounded settings-modal--button px-4 flex justify-center items-center font-medium"
                            onClick={() => form.submit()}
                        >
                            <span className="form-label">{displayMessage('TO_FILTER')}</span>
                        </SL_Button>
                    </div>
                </div>
            }
            closable={false}
            closeIcon={null}
            footer={null}
            width={windowWidth * 0.9}
            bodyStyle={{
                padding: '2.22vh',
            }}
        >
            <Form onFinish={onFinish} className="w-full flex flex-wrap settings-modal-configs-form-divisions" layout="vertical" requiredMark={false} form={form} autoComplete="dontshow">
                {filters.includes('actionDescrition') && (
                    <FormItem className={'flex flex-col w-[45%]'} name="actionDescrition" required={false} label={displayMessage('ACTION_DESCRIPTION')}>
                        <SL_Input className={'w-full font-bold shadow-md bg-black settings-modal--input text-white'} placeholder={displayMessage('ACTION_DESCRIPTION')} />
                    </FormItem>
                )}
                {filters.includes('userName') && (
                    <FormItem className={'flex flex-col w-[45%]'} name="userName" required={false} label={displayMessage('USER_NAME')}>
                        <SL_Input className={'w-full font-bold shadow-md bg-black settings-modal--input text-white'} placeholder={displayMessage('USER_NAME')} />
                    </FormItem>
                )}
                {filters.includes('deviceName') && (
                    <FormItem className={'flex flex-col w-[45%]'} name="deviceName" required={false} label={displayMessage('DEVICE_NAME')}>
                        <SL_Input className={'w-full font-bold shadow-md bg-black settings-modal--input text-white'} placeholder={displayMessage('DEVICE_NAME')} />
                    </FormItem>
                )}
                {filters.includes('description') && (
                    <FormItem className={'flex flex-col w-[45%]'} name="description" required={false} label={displayMessage('DESCRIPTION')}>
                        <SL_Input className={'w-full font-bold shadow-md bg-black settings-modal--input text-white'} placeholder={displayMessage('DESCRIPTION')} />
                    </FormItem>
                )}
                {filters.includes('active_alert_filterName') && (
                    <FormItem className={'flex flex-col w-[45%]'} name="filterName" required={false} label={displayMessage('DEVICE_CENTRAL_OR_GROUP')}>
                        <SL_Input className={'w-full font-bold shadow-md bg-black settings-modal--input text-white'} placeholder={displayMessage('DEVICE_CENTRAL_OR_GROUP')} />
                    </FormItem>
                )}
                {filters.includes('deviceType') && (
                    <FormItem className={'flex flex-col  w-[45%]'} name="deviceType" label={displayMessage('DEVICE_TYPE')} required={false}>
                        <GS_Select
                            allowClear
                            mode="single"
                            className="w-full font-bold shadow-md bg-black settings-modal--input text-white custom-input"
                            placeholder={displayMessage('DEVICE_TYPE')}
                            dropdownStyle={{ backgroundColor: colors['sl-gray'][700], color: 'white' }}
                            options={deviceTypes}
                            showSearch
                            optionFilterProp="label"
                            notFoundContent={
                                <span className="w-full flex justify-center items-center">
                                    {displayMessage(central ? 'NO_FILTER_DATA_TO_CENTRAL' : 'CHOSE_CENTRAL_TO_SELECTS', [displayMessage('DEVICE_TYPE')])}
                                </span>
                            }
                        />
                    </FormItem>
                )}
                {filters.includes('sector') && (
                    <FormItem className={'flex flex-col  w-[45%]'} name="sector" label={displayMessage('ZONES')} required={false}>
                        <GS_Select
                            allowClear
                            mode="single"
                            className="w-full font-bold shadow-md bg-black settings-modal--input text-white custom-input"
                            placeholder={displayMessage('ZONES')}
                            dropdownStyle={{ backgroundColor: colors['sl-gray'][700], color: 'white' }}
                            options={sectors}
                            showSearch
                            optionFilterProp="label"
                            notFoundContent={
                                <span className="w-full flex justify-center items-center">
                                    {displayMessage(central ? 'NO_FILTER_DATA_TO_CENTRAL' : 'CHOSE_CENTRAL_TO_SELECTS', [displayMessage('ZONES')])}
                                </span>
                            }
                        />
                    </FormItem>
                )}
                {filters.includes('alertType') && (
                    <FormItem className={'flex flex-col  w-[45%]'} name="alertType" label={displayMessage('ALERT_TYPE')} required={false}>
                        <GS_Select
                            allowClear
                            mode="single"
                            className="w-full font-bold shadow-md bg-black settings-modal--input text-white custom-input"
                            placeholder={displayMessage('ALERT_TYPE')}
                            dropdownStyle={{ backgroundColor: colors['sl-gray'][700], color: 'white' }}
                            options={alertTypes}
                            showSearch
                            optionFilterProp="label"
                            notFoundContent={
                                <span className="w-full flex justify-center items-center">
                                    {displayMessage(central ? 'NO_FILTER_DATA_TO_CENTRAL' : 'CHOSE_CENTRAL_TO_SELECTS', [displayMessage('ALERT_TYPE')])}
                                </span>
                            }
                        />
                    </FormItem>
                )}
                {filters.includes('datetime') && (
                    <FormItem className={'flex flex-col  w-[45%]'} name="datetime" label={displayMessage('DATE_AND_HOUR')} required={false}>
                        <RangePicker className="w-full font-bold shadow-md bg-black  text-white settings-modal--search" showTime={{ format: 'HH:mm' }} format="DD/MM/YYYY HH:mm" />
                    </FormItem>
                )}
            </Form>
        </SL_Modal>
    )
}
